// Iron Gate Consulting -- static marketing site content
// All CTAs route to trust.igchq.com per app requirements. No backend needed -- pure content site.

export const TRUST_PORTAL_URL = "https://trust.igchq.com/";
export const SUPPORT_EMAIL = "support@igchq.com";
export const POWERED_BY_TEXT = "Powered by Echo Holding Ventures Inc.";
export const ENTITY_NAME = "Echo Holding Ventures Inc.";

export const heroImage =
  "https://images.unsplash.com/photo-1606788075819-9574a6edfab3?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export const flagImage =
  "https://images.unsplash.com/photo-1621534864185-19a06671ed23?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const tickerItems = [
  "Own Nothing. Control Everything.",
  "U.S. Veteran Owned and Operated",
  "One Portal. Complete Protection.",
  "Military Legal Review Included",
];

export const whyReasons = [
  {
    number: "01",
    text: "I served this country and came home with one mission. To use everything my service gave me to help the people around me.",
    big: true,
  },
  {
    number: "02",
    text: "I was given an opportunity by the veterans association to work toward my VA accreditation. To earn it I need to show a proof of concept, documented cases of families I have genuinely helped. So I am using every military benefit available to make this a no-brainer for you.",
  },
  {
    number: "03",
    text: "The more people I help, the faster I reach my accreditation goal. You help me. I help you. We both win.",
  },
  {
    number: "04",
    text: "I am not here to sell you something. I am here because I served so that families like yours would never have to worry about losing everything they built.",
  },
  {
    number: "05",
    text: "As a retired veteran I also have access to military legal benefits. Every file I take on receives a legal review at no additional charge. That protection is built into everything I do.",
  },
];

export const missionParagraphs = [
  "Everything I offer comes from one place. My military service and my mission to protect families the way I protected this country.",
  "Wealthy families have had access to trusts, asset protection, and legal structures for generations. Most everyday families never knew these tools existed or thought they were too expensive to reach.",
  "That changes here. Because of what I earned through 20 years of service you get access to the same protection. At a price that makes sense.",
  "Your family deserves real protection. Not promises. Not paperwork that sits in a drawer. A structure that actually works when life gets hard.",
];

export const services = [
  {
    icon: "Landmark",
    title: "Living Trust Setup",
    text: "We set up a legally binding living trust that protects your home, savings, and assets from probate, lawsuits, and anything life throws at your family. You see everything first. You only move forward when you are satisfied.",
  },
  {
    icon: "Scale",
    title: "Military Legal Review",
    text: "Through my veteran benefits every file receives a legal review by a licensed attorney at no additional charge. Your trust is not just a document. It is reviewed and validated. Available based on your location. Built into every file we take on.",
  },
  {
    icon: "ShieldCheck",
    title: "Asset Protection Structure",
    text: "Beyond the trust we help you structure your assets so creditors, courts, and outside threats cannot reach what you have built. Own nothing. Control everything. The same structure wealthy families have used for generations.",
  },
];

export const steps = [
  {
    number: "1",
    title: "Step 1. Go Through the Portal.",
    text: "Visit trust.igchq.com and complete your intake at your own pace. The portal walks you through every step including your trust structure, asset protection setup, beneficiaries, and everything your family needs. Takes about 20 to 30 minutes. No pressure no rush.",
  },
  {
    number: "2",
    title: "Step 2. I Call You Personally.",
    text: "Before anything finalizes, before you pay a single dollar, I personally call you. We talk through every question you have. I answer everything. You move forward only when you are completely satisfied.",
  },
  {
    number: "3",
    title: "Step 3. Your Protection Is in Place.",
    text: "Once you are ready your completed trust is released to you. From that moment your home, your assets, your business, and everything you have built are legally protected. I personally walk you through your documents and what comes next. Your family's protection does not start someday. It starts the day your trust is finalized.",
  },
];

export const bankBenefits = [
  { icon: "House", text: "Your home and property are protected from judgment creditors and lawsuits." },
  { icon: "Gavel", text: "Bypasses probate completely. Your family will never be stuck in court for months or years." },
  { icon: "KeyRound", text: "Assets are controlled by YOU. Not banks not courts not the government." },
  { icon: "Users", text: "Generational wealth transfers smoothly to your children and grandchildren." },
  { icon: "Infinity", text: "Works while you are alive AND after. Unlike a will which only activates at death." },
  { icon: "BadgeCheck", text: "Every file reviewed through veteran military legal benefits." },
];

export const pricingTiers = [
  {
    name: "Basic Trust",
    price: "$1,497",
    text: "Your trust is legally valid and your assets are fully protected. Probate is avoided. Your family is covered. This is where most people start and it is solid protection. It is on public record. Someone who knows where to look can find it.",
    recommended: false,
  },
  {
    name: "Private Trust",
    price: "$2,497",
    text: "Your trust is completely invisible to the outside world. No public record. No one can search your name and find what you own. Your assets are protected and untraceable. This is what wealthy families actually use. Own everything. Appear to own nothing.",
    recommended: true,
  },
];

export const whoWeServe = [
  { title: "Homeowners", image: "https://images.unsplash.com/photo-1713942590368-09cfc6ae94ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { title: "Families", image: "https://images.unsplash.com/photo-1624448445915-97154f5e688c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { title: "Veterans", image: "https://images.pexels.com/photos/7984335/pexels-photo-7984335.jpeg?auto=compress&cs=tinysrgb&w=900" },
  { title: "Business Owners", image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { title: "Building Wealth", image: "https://images.unsplash.com/photo-1758686253692-2d6921de12dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { title: "Want Privacy", image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
];

export const testimonials = [
  {
    quote:
      "He called me himself before I paid anything and walked me through every single page. For the first time I actually understand what protects my house and my kids.",
    name: "Denise M.",
    role: "Homeowner and mother of three",
    image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  },
  {
    quote:
      "I had a trust from years ago sitting in a drawer. He reviewed it for free, showed me exactly what was missing, and fixed it. No pressure at any point.",
    name: "Robert T.",
    role: "Small business owner",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  },
  {
    quote:
      "As a fellow veteran's spouse, working with someone who served meant everything. The legal review was included and everything was done right the first time.",
    name: "Angela P.",
    role: "Military family",
    image: "https://images.pexels.com/photos/31530222/pexels-photo-31530222.jpeg?auto=compress&cs=tinysrgb&w=300",
  },
];

export const faqItems = [
  {
    question: "Is a living trust really different from a will?",
    answer:
      "Yes, completely. A will only takes effect after you die and usually sends your family through probate court. A living trust works for you while you are still alive. It manages your assets, protects you if you become incapacitated, avoids probate entirely, and passes everything to your family without delay.",
  },
  {
    question: "Do I have to pay anything before I see my trust?",
    answer:
      "No. You go through the portal at your own pace, see your entire trust structure laid out, and I personally call you to walk through every page. You only pay once you are completely satisfied and ready to move forward.",
  },
  {
    question: "How long does the process take?",
    answer:
      "The portal intake takes about 20 to 30 minutes. After that, I personally call you to answer every question. There is no countdown clock and no pressure. We move at whatever pace makes you comfortable.",
  },
  {
    question: "Is the legal review really included at no extra charge?",
    answer:
      "Yes. Through my veteran benefits, every file I take on is reviewed by a licensed attorney at no additional cost to you. It is built into the process, not an upsell, and availability is based on your location.",
  },
  {
    question: "What is the difference between the Basic and Private trust?",
    answer:
      "The Basic Trust is fully valid and fully protects your family, but it sits on public record. The Private Trust is completely invisible to the outside world, meaning no public record and no way for anyone to search your name and find what you own. Both protect you. Only one makes you invisible.",
  },
  {
    question: "I already have a trust. Should I still reach out?",
    answer:
      "Yes. Most trusts I review are either sitting empty, missing key protections, or were written under laws that have since changed. Send it to me and I will review it at no cost and tell you exactly where you stand.",
  },
];

export const finalCtaBadges = [
  { icon: "PhoneCall", text: "Personal call before you pay." },
  { icon: "Scale", text: "Military legal review included." },
  { icon: "ShieldCheck", text: "Protection in place from day one." },
];
